VjsAdmin.OneRosterForm = (function () {
    const dangerAlert = function (alertMessage) {
        const $alert = $('<div>').addClass('alert alert-danger').attr('role', 'alert');
        $alert.append($('<span>').text(alertMessage));
        $('.alert-div').empty().append($alert);
    };

    const init = function () {
        VjsAdmin.initDateRangePickers($('#oneroster-form'));

        // convert database date from UTC to local time in format MM/DD/YYYY
        if (typeof $('#start_date').val() !== 'undefined' && $('#start_date').val() !== null && $('#start_date').val() !== '') {
            $('#start_date').val(moment($('#start_date').val()).format('MM/DD/YYYY'));
        } else {
            $('#start_date').val(moment(new Date()).format('MM/DD/YYYY'));
        }

        if (typeof $('#end_date').val() !== 'undefined' && $('#end_date').val() !== null && $('#end_date').val() !== '') {
            $('#end_date').val(moment($('#end_date').val()).format('MM/DD/YYYY'));
        } else {
            $('#end_date').val(moment(Date.parse('01 Jan 2035')).format('MM/DD/YYYY'));
        }

        // convert submitted dates from local timezone to UTC
        $('form#oneroster-form').submit(() => {});

        $('#timepicker').datetimepicker({
            format: 'LT',
            icons: {
                time: 'fa-regular fa-clock',
                date: 'fa fa-calendar',
                up: 'fa fa-hand-o-up',
                down: 'fa fa-hand-o-down',
            },
        });

        $('#timepicker').on('click', 'input', () => {
            $('#timepicker').data('DateTimePicker').show();
        });

        // convert time from database from utc to eastern
        if (typeof $('#time-of-day').val() !== 'undefined' && $('#time-of-day').val() !== null && $('#time-of-day').val() !== '') {
            const datetime = moment.utc(`${moment().format('YYYY-MM-DD')} ${$('#time-of-day').val()}`, 'YYYY-MM-DD h:mm A');
            $('#time-of-day').val(datetime.utc().tz('America/New_York').format('h:mm A'));
        }

        // convert submitted time from local timezone to UTC
        $('form#oneroster-form').submit(() => {
            if (typeof $('#time-of-day').val() !== 'undefined' && $('#time-of-day').val() != null && $('#time-of-day').val() !== '') {
                const datetime = moment(`${moment().format('YYYY-MM-DD')} ${$('#time-of-day').val()}`, 'YYYY-MM-DD h:mm A');
                $('#time-of-day').val(datetime.utc().format('h:mm A'));
            }
            return true;
        });

        const updateFields = function () {
            const frequency = $('#frequency').val();
            const enabled = $('#oneroster-enabled').is(':checked');

            if (+enabled === 1) {
                $('#oneroster-form #sftp-folder').prop('required', true);
            }

            switch (frequency) {
                case 'daily':
                    $('#day-of-week-container').hide();
                    $('#day-of-week').prop('disabled', true).prop('required', false);
                    $('#day-of-month-container').hide();
                    $('#day-of-month').prop('disabled', true).prop('required', false);
                    break;
                case 'weekly':
                    $('#day-of-week-container').show();
                    $('#day-of-week').prop('disabled', false).prop('required', true);
                    $('#day-of-month-container').hide();
                    $('#day-of-month').prop('disabled', true).prop('required', false);
                    break;
                case 'monthly':
                    $('#day-of-month-container').show();
                    $('#day-of-month').prop('disabled', false).prop('required', true);
                    $('#day-of-week-container').hide();
                    $('#day-of-week').prop('disabled', true).prop('required', false);
                    break;
                default:
                    break;
            }

            if (+enabled === 0) {
                $('#oneroster-form input, #oneroster-form select').prop('required', false);
            }
        };

        $('#oneroster-enabled').on('change', updateFields);
        $('#frequency').on('change', updateFields);
        $('#oneroster-remove-rostering').on('click', (e) => {
            e.preventDefault();
            if (
                window.confirm(
                    'Are you sure you want to remove the connections?\n\n'
                        + 'This will remove all user and license rostering connection data.',
                )
            ) {
                const mybutton = $('#oneroster-remove-rostering');
                const platformId = mybutton.attr('data-platform-id');
                const districtGuid = mybutton.attr('data-district-joint-guid');
                const connectionType = mybutton.attr('data-connection-type');
                const req = new VjsUtility.Request();
                req.delete(`/platforms/${platformId}/districts/${districtGuid}/rostering/${connectionType}/`)
                    .done(() => {
                        VjsUtility.Notification.success('Rostering connections removed successfully!');
                    })
                    .fail((x) => {
                        dangerAlert(x.responseJSON.data);
                        VjsUtility.Notification.error(x.responseJSON.data);
                    });
            }
        });

        updateFields();
    };

    return {
        init,
    };
}());
